export const SET_SIDEBAR = "HEADER/SET_SIDEBAR";
export const SHOW_ACTIVE = "HEADER/SHOW_ACTIVE";
export const FETCH_URL = "HEADER/FETCH_URL";

export const fetchBegin = sidebarXFP => ({
  type: FETCH_URL,
  sidebarXFP
});
export const enablesidebarXFP = sidebarXFP => ({
  type: SET_SIDEBAR,
  sidebarXFP /* ,
  sidebarPIC */
});

export const showActiveSideBar = () => ({
  type: SHOW_ACTIVE
});
export default function reducer(
  state = {
    sidebarXFP: true,
    sidebarPIC: false
  },
  action
) {
  switch (action.type) {
    case FETCH_URL:
      return {
        ...state,
        sidebarXFP: action.sidebarXFP
        /*  sidebarPIC: !state.sidebarPIC */
      };
    case SET_SIDEBAR:
      return {
        ...state,
        sidebarXFP: !state.sidebarXFP
        /*  sidebarPIC: !state.sidebarPIC */
      };
    case SHOW_ACTIVE:
      return { state /* , sidebarPIC */ };
    default:
      console.log("EII", action);
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/Header.js